import React from "react";
import { ChangePasswordLoaderTemplate } from "themes/common/components";

function ChangePasswordLoader(props) {
    return <ChangePasswordLoaderTemplate {...props} />;
}

export default ChangePasswordLoader;
